module.exports = __webpack_public_path__ + "static/media/cardImg5.43f9dac6.jpg";